import { useMutation } from '@tanstack/react-query';
import { deleteRule, restoreRule } from '@/features/agreements/services/rulesService';

export const useDeleteRule = () => {
  return useMutation({
    mutationFn: ({ ruleGroupId, ruleId }) => deleteRule(ruleGroupId, ruleId),
  });
};

export const useRestoreRule = () => {
  return useMutation({
    mutationFn: ({ ruleGroupId, ruleId }) => restoreRule(ruleGroupId, ruleId),
  });
};
